import React ,{useState, useEffect}from 'react';
import {
    Button, InputGroup, InputGroupText,
    Card,Badge,Spinner, Table,
    CardHeader,Collapse,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Form,
    Input,
    Row,Label,Modal,
    Col,
    Container,
    ModalHeader,
    ModalBody,
  } from "reactstrap";
import Features from './adminreq/Features.js'
import Vehiclereq from './adminreq/Vehiclereq.js'
import Brandreq from './adminreq/Brandreq.js'

function Adminreq(props) {
    const [sfshow, setSfshow] = useState(false)
    const [svshow, setSvshow] = useState(false)
    const [sbshow, setSbshow] = useState(false)
    const [showProcessing , setShowProcessing] = useState(false)
    const [data , setData] = useState({
        brand : [],
        vehicle : [],
        feature : []        
    })
    const [vehicle , setVehicle ] = useState({
        reqid: "",
        vid : "",
        categoryCode : "", 
        category : {en : "", fr : "", ar : ""},
        bid : "",
        blogo : "",
        bname :   {en : "", fr : "", ar : ""},
        mname :  {en : "", fr : "", ar : ""},
        modelyear : {value : "", label :""},
        notes : "",
        vtypeCode : "",
        vtname : {en : "", fr : "", ar : ""},
        features: [{featureCode : "", en : "", fr : "", ar : "", unit : "", rangeid : "" , rangevalueL : "" , rangevalueH: ""}]
      })
      const [features, setFeatures] = useState({
        categoryCode :"", categoryName : "", featureCode : "", en : "", fr : "", ar : "", unit : "", valueRange : [], reqid: ""}
        )   

    const [flen, setFlen] = useState(0)
    const [vlen, setVlen] = useState(0)  
    const [blen, setBlen] = useState(0)  

    const errorhandler = (error) => {
        try{
          if(error.response.status === 401){
            props.swal("Unauthorized, please login again.").then(t => {
                props.history.push(`/auth/login`)
            })   
          }else{
            props.swal(error.response.data.message)
          }
        } catch(e){
          props.swal("error processing request at this time, please contact support.")
        } 
      
      }

    useEffect(() => {
        populatedata()
    },[])

    useEffect(() => {
        populatedata()
    },[svshow, sfshow, sbshow])

    
    const [selectedbrand, setSelectedBrand] = useState({
        bid : "", bname : {en : "", fr :"", ar : ""},
        blogo : "",reqid: ""
    })

   

    const populatedata = () => {
        setShowProcessing(true)
        props.API.get(`ten/requests`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            setShowProcessing(false)
           setData({brand : res.data.brand, vehicle : res.data.vehicle, feature : res.data.feature})
           let vhdata = res.data.vehicle.sort((a, b) => a.rDate > b.rDate ? -1 : 1) 
           let frdata = res.data.feature.sort((a, b) => a.rDate > b.rDate ? -1 : 1) 
           let uavhd = res.data.feature.filter(g =>  g.astatus === undefined)
           let uavh = res.data.vehicle.filter(g =>  g.astatus === undefined)
           let bavh = res.data.brand.filter(g =>  g.astatus === "Pending")
           setFlen(uavhd.length)
           setVlen(uavh.length)
           setBlen(bavh.length)
           
     }).catch(function (error) {
        setShowProcessing(false)
        errorhandler(error)
          })
                
          
       
    }

    const showFeature = () => {
        return (
            <Modal isOpen={sfshow} size="xl">
                <ModalHeader >
                Request Feature<span style={{float : "right"}}><i className="fa fa-times-circle" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={y => {setSfshow(false);setFeatures(
                    {  categoryCode :"", categoryName : "",  featureCode : "", en : "", fr : "", ar : "", unit : "", valueRange : [], reqid: ""}
                )}} ></i></span>
                </ModalHeader>
                <ModalBody>
                    <Features API={props.API} swal={props.swal} features ={features} populatedata={populatedata} setSfshow={setSfshow}/>
                </ModalBody>
            </Modal>
        )
    }

    const showVehicle = () => {
        return (
            <Modal  isOpen={svshow} size="lg">
                <ModalHeader >
                    Request Vehicles <span style={{float : "right"}}><i className="fa fa-times-circle" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={y => {setSvshow(false);setVehicle({
                         reqid: "",
                         vid : "",
                         categoryCode : "", 
                         category : {en : "", fr : "", ar : ""},
                         bid : "",
                         blogo : "",
                         bname :   {en : "", fr : "", ar : ""},
                         mname :  {en : "", fr : "", ar : ""},
                         modelyear : {value : "", label :""},
                         notes : "",
                         vtypeCode : "",
                         vtname : {en : "", fr : "", ar : ""},
                         features: [{featureCode : "", en : "", fr : "", ar : "", unit : "", rangeid : "" , rangevalueL : "" , rangevalueH: ""}]
                    })}} ></i></span>
                </ModalHeader>
                <ModalBody>
                    <Vehiclereq API={props.API} swal={props.swal} vehicle={vehicle} populatedata={populatedata} setSvshow={setSvshow}/>
                </ModalBody>
            </Modal>
        )
    }

    const showBrand = () => {
        return (
            <Modal isOpen={sbshow}>
                <ModalHeader  >
                    Request Brand <span style={{float : "right"}}><i className="fa fa-times-circle" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={y => {setSbshow(false);setSelectedBrand({
        bid : "", bname : {en : "", fr :"", ar : ""},
        blogo : "", reqid : ""
    }       )}} ></i></span>
                </ModalHeader>
                <ModalBody>
                    <Brandreq API = {props.API} swal={props.swal} selectedbrand={selectedbrand} setSbshow={setSbshow} populatedata={populatedata}/>
                </ModalBody>
            </Modal>
        )
    }

    const retfeat = () => {
        try{
            return (
                data.feature.map((x, key) =>{
                    return (
                        <tr key={key}>
                            <td>{new Date(x.rDate).toLocaleDateString("en-GB")}</td>
                            <td>{x.categoryName.en}</td>
                            <td>{x.features[0].en}</td>
                            <td>{x.astatus || "Pending"}</td>
                            <td><i className="fa fa-info-circle" aria-hidden="true" style={{cursor : "pointer"}} onClick={o => {setFeatures(x); setSfshow(true)}}></i>&emsp;<i className="fa fa-trash" aria-hidden="true" style={{float : "right", cursor : "pointer", marginTop : 3}} onClick={g => delreq("Feature", x.reqid)}></i></td>
                        </tr>
                    )
                })
            )
        }catch(e){

        }
       
    }
    const retveh = () => {
        try{
            return (
                data.vehicle.map((x, key) =>{
                 
                    return (
                        <tr key={key}>
                            <td>{new Date(x.rDate).toLocaleDateString("en-GB")}</td>
                            <td>{x.bname.en}</td>
                            <td>{x.mname.en}</td>
                            <td>{x.astatus || "Pending"}</td>
                            <td><i className="fa fa-info-circle" aria-hidden="true" style={{cursor : "pointer"}} onClick={o => {setVehicle(x); setSvshow(true)}}></i>&emsp;<i className="fa fa-trash" aria-hidden="true" style={{float : "right" , cursor : "pointer", marginTop : 3}} onClick={g => delreq("Vehicle", x.reqid)}></i></td>
                        </tr>
                    )
                })
            )
        }catch(e){

        }
       
    }
    const retbra = () => {
        try{
            return (
                data.brand.map((x, key) =>{
                 
                    return (
                        <tr key={key}>
                            <td>{x.bname.en}</td>
                            <td>{x.astatus || "Pending"}</td>
                            <td><i className="fa fa-info-circle" aria-hidden="true" style={{cursor : "pointer"}} onClick={o => {setSelectedBrand(x); setSbshow(true)}}></i>&emsp;<i className="fa fa-trash" aria-hidden="true" style={{float : "right", cursor : "pointer", marginTop : 3}} onClick={g => delreq("Brand", x.reqid)}></i></td>
                        </tr>
                    )
                })
            )
        }catch(e){

        }
       
    }

    const delreq = (stype, reqid) => {
        props.API.post(`ten/delreq`, {stype , reqid},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            props.swal(res.data.message)
            if(stype === "Brand"){
                let nlist = data.brand.filter(t => t.reqid !== reqid)
                setData({...data , brand  : nlist})    
            }else if(stype === "Vehicle"){
                let nlist = data.vehicle.filter(t => t.reqid !== reqid)
                setData({...data , vehicle  : nlist})    
            }else if(stype === "Feature"){
                let nlist = data.feature.filter(t => t.reqid !== reqid)
                setData({...data , feature  : nlist})    
            }
            
            setShowProcessing(false)
          //  dispatch(profileFetch(props.user.tuid))
          }).catch(function (error) {
            setShowProcessing(false)
              console.log(error)
              errorhandler(error)
          })
    }

    return (
        <div className='content'>
              {showProcessing && props.Spin } 
              
            {showBrand()}
            {showVehicle()}
            {showFeature()}
            
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                        <Row>
                            <Col><h6>Features</h6> </Col>
                            <Col><h6>Total : {data.feature.length}</h6></Col>
                            <Col><h6>Pending : {flen}</h6></Col>
                            <Col><i className="fa fa-hand-pointer-o fa-lg" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={h => setSfshow(true)}></i></Col>
                        </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col>
                    <Card>
                        <CardBody>
                        <Row>
                            <Col><h6>Models</h6> </Col>
                            <Col><h6>Total : {data.vehicle.length}</h6></Col>
                            <Col><h6>Pending : {vlen}</h6></Col>
                            <Col><i className="fa fa-hand-pointer-o fa-lg" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={h => setSvshow(true)}></i></Col>
                        </Row> 
                        </CardBody>
                    </Card>
                </Col>
               
                <Col>    
                <Card>
                    <CardBody>
                        <Row>
                            <Col><h6>Brands</h6> </Col>
                            <Col><h6>Total : {data.brand.length}</h6></Col>
                            <Col><h6>Pending : {blen}</h6></Col>
                            <Col><i className="fa fa-hand-pointer-o fa-lg" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={h => setSbshow(true)}></i></Col>
                        </Row> 
                    </CardBody>
                    </Card>   
                </Col>
             
            </Row>

            <Row>
                <Col>
                <Card>
                    <CardBody>
                    <Table>
                        <thead>
                            <tr>
                                 <th></th>
                                <th>Category</th>
                                <th>Feature</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        
                        <tbody>
                            {
                              retfeat()
                            }
                        </tbody>
                    </Table>
                    </CardBody>
                </Card>
                 
                </Col>
                <Col>
                    <Card>
                        <CardBody>
                        <Table>
                        <thead>
                            <tr>
                                 <th></th>
                                <th>Brand</th>
                                <th>Model</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                              retveh()
                            }
                        </tbody>
                    </Table>
                        </CardBody>
                    </Card>
               
                </Col>
                
                <Col>
                <Card>
                    <CardBody>
                    <Table>
                        <thead>
                            <tr>
                                <th>Brand</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                              retbra()
                            }
                        </tbody>
                    </Table>
                    </CardBody>
                </Card>
                
                </Col>
                
            </Row>    
            
            
        </div>
    );
}

export default Adminreq;